import React from "react";
import { styled } from "@mui/system";
import { Checkbox, FormControlLabel } from "@mui/material";
import GlobalTheme from "../../../styles/global.theme";

export const CustomFormControlLabel = styled(FormControlLabel)`
    margin-left: 0;
    align-items: center;

    .MuiTypography-root {
        font-size: 18px;
        color: ${GlobalTheme.palette.black.primary.main};
        padding: 0 0 0 8px;
        line-height: 1.5;
    }

    .MuiCheckbox-root {
        margin: 0 0 0 10px;
        align-self: center;
    }
`;

const CheckboxWithLabel = ({
    name,
    disabled,
    size,
    checked,
    onChange,
    label,
    inputProps,
    ...props
}) => {
    return (
        <CustomFormControlLabel
            control={
                <Checkbox
                    name={name}
                    disabled={disabled}
                    size={size}
                    checked={checked}
                    onChange={onChange}
                    inputProps={inputProps}
                    sx={{
                        "&.Mui-checked": {
                            color: !disabled
                                ? `${GlobalTheme.palette.purple.primary.main}!important`
                                : undefined,
                        },
                        "&.MuiCheckbox-root": {
                            color: !disabled
                                ? GlobalTheme.palette.purple.primary.main
                                : undefined,
                            margin: 0,
                            padding: 0,
                        },
                        "input:hover ~ &": {
                            backgroundColor: !disabled
                                ? `${GlobalTheme.palette.white.primary.main}!important`
                                : "transparent",
                        },
                    }}
                />
            }
            label={label}
            {...props}
        />
    );
};

export default CheckboxWithLabel;
